export default class MailApi
{
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(MailApi.ContactUsPath);
        this.DashAPI.ApiPathMgr.add(MailApi.EmailSignupPath);
        this.DashAPI.ApiPathMgr.add(MailApi.ViewMlsPropertyPath);
        this.DashAPI.ApiPathMgr.add(MailApi.ViewParagonPropertyPath);
    }

    postContactUs(data) {
        return this.DashAPI.CORE.postFormData(MailApi.ContactUsPath, data);
    }

    postEmailSignup(data) {
        return this.DashAPI.CORE.postFormData(MailApi.EmailSignupPath, data);
    }

    postViewMlsProperty(data) {
        return this.DashAPI.CORE.postFormData(MailApi.ViewMlsPropertyPath, data);
    }

    postViewParagonProperty(data) {
        return this.DashAPI.CORE.postFormData(MailApi.ViewParagonPropertyPath, data);
    }
}

MailApi.ContactUsPath = '/api/mail/contact-us';
MailApi.EmailSignupPath = '/api/mail/email-signup';
MailApi.ViewMlsPropertyPath = '/api/mail/view-mls-property';
MailApi.ViewParagonPropertyPath = '/api/mail/view-paragon-property';



// WEBPACK FOOTER //
// ./src/PublicApi/mail/MailApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/mail/MailApi.js